import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="10" viewBox="0 0 16 10" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14.846 0H1.154C.518 0 0 .518 0 1.154v7.692C0 9.482.518 10 1.154 10h13.692C15.482 10 16 9.482 16 8.846V1.154C16 .518 15.482 0 14.846 0zM9 7.998L7 8V5L5.5 6.923 4 5v3H2V2h2l1.5 2L7 2l2-.002v6zm2.986.5L9.5 5H11V2h2v3h1.5l-2.514 3.498z" fill="currentColor" fillRule="nonzero" /></svg>);